import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
/*import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'*/

export default function useRincianPenerimaanList(id_penerimaan) {
  // Use toast
  /*const toast = useToast()*/

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
      { key: 'kd_produk', sortable: true },
      { key: 'harga_beli', sortable: true },
      { key: 'discount', sortable: false,'label' : 'Diskon' },
      { key: 'qty', sortable: true},
      { key: 'catatan', sortable: false },
      { key: 'jumlah_harga'},
      { key: 'actions' },
  ]
  const perPage = ref(15)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('created_at')
  const isSortDirDesc = ref(true)
  const tglTerimaFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    fetchPenerimaanRincians()
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, tglTerimaFilter, statusFilter], () => {
    refetchData()
  })

  const fetchPenerimaanRincians = (ctx, callback) => {
    store
      .dispatch('app-penerimaan/fetchPenerimaanRincians', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
        tglTerima:tglTerimaFilter.value,
        id: id_penerimaan

      })
      .then(response => {
        const { data, total } = response.data
        callback(data)
        totalUsers.value = total
      })
      .catch(() => {
        /*toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })*/
      })
  }

  return {
      fetchPenerimaanRincians,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    refetchData,

    // Extra Filters
    tglTerimaFilter,
    statusFilter,
  }
}
